module.exports = __webpack_public_path__ + "static/media/say.44112144.png";